<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'
import { get } from 'lodash'

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Input({
              label: 'Tytuł',
              modelPath: [this, 'form', 'title'],
              multilingual: true
            }),
            new fields.WYSIWYG({
              label: 'Opis',
              modelPath: [this, 'form', 'description'],
              multilingual: true
            }),
            new fields.Image({
              label: 'Zdjęcie',
              modelPath: [this, 'form', 'image']
            }),
            new fields.Input({
              label: 'Tekst w rogu',
              modelPath: [this, 'form', 'corner_text'],
              multilingual: true
            }),
            new fields.Input({
              label: 'Tekst nad tytułem',
              modelPath: [this, 'form', 'top_text'],
              multilingual: true
            })
          ]
        }
      ]
    }
  }
}
</script>
